import { useState } from "react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const INTERESTS = [
  "General",
  "Investor Discussion",
  "Venue / Promoter Partnership",
  "Crew / Production",
  "Corporate / Brand",
  "Careers",
];

const inputCls =
  "w-full border border-line bg-white px-4 py-3.5 text-sm text-charcoal-900 placeholder:text-slate-400 outline-none transition-all duration-200 focus:border-accent focus:ring-2 focus:ring-accent/15";

const ContactForm = () => {
  const [form, setForm] = useState({ name: "", email: "", interest: INTERESTS[0], message: "" });
  const [sending, setSending] = useState(false);

  const update = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (sending) return;
    setSending(true);
    try {
      const res = await fetch(`${API}/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error("failed");
      toast.success("Message sent. The True Life team will be in touch shortly.");
      setForm({ name: "", email: "", interest: INTERESTS[0], message: "" });
    } catch {
      toast.error("Something went wrong. Email us at info@truelifeentertainment.com");
    } finally {
      setSending(false);
    }
  };

  return (
    <form data-testid="contact-form" onSubmit={submit} className="border border-line bg-white p-7 sm:p-9">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <label htmlFor="ct-name" className="mb-2 block font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-steel">Name</label>
          <input id="ct-name" data-testid="contact-name-input" className={inputCls} placeholder="Your name" value={form.name} onChange={update("name")} required />
        </div>
        <div>
          <label htmlFor="ct-email" className="mb-2 block font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-steel">Email</label>
          <input id="ct-email" type="email" data-testid="contact-email-input" className={inputCls} placeholder="you@company.com" value={form.email} onChange={update("email")} required />
        </div>
      </div>

      <div className="mt-4">
        <label htmlFor="ct-interest" className="mb-2 block font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-steel">Inquiry type</label>
        <select id="ct-interest" data-testid="contact-interest-select" className={`${inputCls} appearance-none`} value={form.interest} onChange={update("interest")}>
          {INTERESTS.map((i) => (
            <option key={i} value={i}>{i}</option>
          ))}
        </select>
      </div>

      <div className="mt-4">
        <label htmlFor="ct-message" className="mb-2 block font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-steel">Message</label>
        <textarea id="ct-message" data-testid="contact-message-input" rows={5} className={`${inputCls} resize-none`} placeholder="Tell us how you'd like to work together..." value={form.message} onChange={update("message")} required />
      </div>

      <button
        type="submit"
        data-testid="contact-submit-button"
        disabled={sending}
        className="mt-6 w-full bg-accent py-4 font-mono text-xs font-semibold uppercase tracking-[0.2em] text-white transition-colors duration-200 hover:bg-accent-dark disabled:opacity-60"
      >
        {sending ? "Sending..." : "Send Message"}
      </button>
    </form>
  );
};

export default ContactForm;
